import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from "../contexts/AuthContext";
import { useQuery } from '@tanstack/react-query';
import { invitationService } from '../apiClient';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './fielder_style.css';
import { LogIn, UserPlus } from 'lucide-react';
import Avatar from './Avatar';

function LoginOrSignup() {
    const { currentUser, currentUserObject } = useAuth();

    const { data: pendingInvitations = [] } = useQuery({
      queryKey: ['invitations', 'pending'],
      queryFn: invitationService.getPending,
      enabled: !!currentUser,
      staleTime: 60_000,
    });

    if (currentUser && currentUserObject) {
      return (
        <div className="d-flex align-items-center position-relative">
          <Link
            to="/profile"
            className="btn btn-sm rounded-pill d-flex align-items-center gap-2 px-3"
            style={{
              backgroundColor: 'var(--field-green)',
              borderColor: 'var(--field-green)',
              color: 'white',
              textDecoration: 'none'
            }}
          >
            <Avatar
              name={currentUserObject.getUserFName()}
              email={currentUser.email}
              src={currentUserObject.getUserPhotoURL()}
              size={22}
              decorative
              style={{ marginLeft: -4, boxShadow: 'inset 0 0 0 1px rgba(0, 0, 0, 0.06), 0 0 0 1px rgba(255, 255, 255, 0.5)' }}
            />
            <span className="fw-medium">{currentUserObject.getUserFName() ?? "Guest"}</span>
          </Link>
          {pendingInvitations.length > 0 && (
            <span
              className="position-absolute rounded-circle"
              style={{
                width: 10, height: 10,
                backgroundColor: '#f59e0b',
                top: -1, right: -1,
                border: '2px solid white',
                pointerEvents: 'none',
              }}
            />
          )}
        </div>
      );
    } else {
      return (
        <div className="auth-links d-flex align-items-center gap-2">
          <Link 
            to="/login" 
            className="btn btn-sm btn-outline-secondary rounded-pill d-flex align-items-center gap-2 px-3"
            style={{textDecoration: 'none'}}
          >
            <LogIn size={14} />
            <span>Log in</span>
          </Link>
          <Link 
            to="/signup" 
            className="btn btn-sm rounded-pill d-flex align-items-center gap-2 px-3"
            style={{
              backgroundColor: 'var(--field-green)', 
              borderColor: 'var(--field-green)', 
              color: 'white',
              textDecoration: 'none'
            }}
          >
            <UserPlus size={14} />
            <span>Sign up</span>
          </Link>
        </div>
      );
    }
  }
  
  export default LoginOrSignup;
